import { TravailStubPage } from '../../../../components/parcours/TravailStubPage';
import { getTravailStub } from '../../../../config/travaux-particuliers';

export default function PoeleAGranulesPage() {
  const travail = getTravailStub('poele-a-granules');
  if (!travail) return null;
  return <TravailStubPage travail={travail} />;
}
